import { useState } from 'react';
import { StoreProvider, useStore } from './store';
import Gate from './Gate';
import ChallanTool from './challan/ChallanTool';

export default function InternalApp() {
  return (
    <StoreProvider>
      <Shell />
    </StoreProvider>
  );
}

function Shell() {
  const { authed, data, dirty, saveFile, lock } = useStore();
  const [tab, setTab] = useState('challan');

  if (!authed || !data) return <Gate />;

  return (
    <div className="min-h-screen bg-base-100">
      <div className="border-b border-base-300 bg-base-200">
        <div className="flex items-center justify-between px-4 py-2">
          <div className="tabs tabs-boxed bg-base-200">
            <a className={`tab ${tab === 'challan' ? 'tab-active' : ''}`}
               onClick={() => setTab('challan')}>Delivery Challan</a>
            {/* Add more tools here as new tabs */}
          </div>
          <div className="flex items-center gap-2">
            {dirty
              ? <span className="badge badge-warning">Unsaved changes</span>
              : <span className="badge badge-ghost">Saved</span>}
            <button className="btn btn-sm btn-primary" onClick={saveFile}>
              Save data file
            </button>
            <button className="btn btn-sm btn-ghost" onClick={() => {
              if (dirty && !window.confirm('Discard unsaved changes?')) return;
              lock();
            }}>Lock</button>
          </div>
        </div>
      </div>

      <div className="p-4">
        {tab === 'challan' && <ChallanTool />}
      </div>
    </div>
  );
}
